import { render, staticRenderFns } from "./scan-result.vue?vue&type=template&id=82327f08&scoped=true&"
import script from "./scan-result.vue?vue&type=script&lang=js&"
export * from "./scan-result.vue?vue&type=script&lang=js&"
import style0 from "./scan-result.vue?vue&type=style&index=0&id=82327f08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82327f08",
  null
  
)

export default component.exports